import React from 'react'

type AwaitProps<T> = {
  dependency:Promise<T>
  intermediate?:'undefined' | 'keep' | T
  children:(_:T) => React.ReactNode
  fallback?:React.ReactNode
}

// const structurallyEqual = <T,>(x:T,y:T) : boolean => {
//   if(typeof x === typeof y)
//   {
//     if(Array.isArray(x) && Array.isArray(y))
//     {
//       return x.length === y.length && x.map((x,i) => structurallyEqual(x,y[i])).every((x) => x)
//     }
//     else if(typeof x === 'object')
//     {
//       return structurallyEqual(Object.entries(x ?? {}).sort(),Object.entries(y ?? {}).sort())
//     }
//     else if(typeof x === 'function')
//     {
//       return false
//     }
//     else
//     {
//       return x === y
//     }
//   }
//   else
//   {
//     return false
//   }
// }

// const construct = <a,>(props:AwaitProps<a>) => React.lazy(async () : Promise<{ default:() => React.ReactNode }> => {
//   const value = await props.dependency
//   return { 'default':() => props.children(value) }
// })

// const Await = <T,>(props:AwaitProps<T>) : React.ReactNode => {
//   const [Content,setContent] = React.useState<React.LazyExoticComponent<() => React.ReactNode>>()
//   React.useEffect(() => {
//     setContent(construct(props))
//   },[props.dependency])
//   return Content ? (
//     <React.Suspense fallback={props.fallback}>
//       <Content/>
//     </React.Suspense>
//   ) : undefined
// }

const Await = <T,>(props: AwaitProps<T>) : React.ReactNode => {
  const [value, setValue] = React.useState<T | undefined>()
  // console.log('Await - rendering',props,React["__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED"].ReactDebugCurrentFrame.getCurrentStack())
  React.useEffect(() => {
    let ignore = false
    if(props.intermediate !== 'keep')
    {
      setValue(props.intermediate === 'undefined' || props.intermediate === undefined ? undefined : props.intermediate)
    }
    ;(async () => {
      const value_ = await props.dependency
      if(!ignore)
      {
        setValue(value_)
      }
    })()
    return () => { ignore = true }
  },[props.dependency])

  return (value === undefined ? props.fallback : props.children(value))
}

export default React.memo(Await) as typeof Await
